import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import { FaBullseye ,  FaCashRegister, FaCheckCircle } from 'react-icons/fa';
import { getUsers } from 'data/apiConection.js/dataUsers';
import { updateCuotasFull } from 'data/apiConection.js/dataCuotas';
const columns = (handleButtonPayed, setCuotaId) => [
  {
    accessor: 'mes',
    Header: ' Mes',
    width: 200,        // ancho fijo
    minWidth: 180,     // ancho mínimo
    maxWidth: 250,  
    headerProps: {
      className: 'py-3 ps-0'
    },
    cellProps: {
      className: 'ps-0'
    },
    Cell: rowData => {
      return (
        <Link to="#!" className="text-800">
          <Flex alignItems="center">
            <h6 className="mb-0 ps-2">{rowData.row.original.mes}</h6>
          </Flex>
        </Link>
      );
    }
  },
  {
    accessor: 'monto',
    Header: 'Monto',
    Cell: rowData => {
      return (
        <a className="mb-0">
          {rowData.row.original.monto?"$ "+rowData.row.original.monto:"$ "+0}
        </a>
      );
    }
  },
  {
    accessor: 'status',
    Header: 'Status',
    Cell: rowData => {
      return (
        <SoftBadge pill bg={rowData.row.original.status=='pagado'?'success':'warning'} className="me-2">
          {rowData.row.original.status}
        </SoftBadge>
      );
    }
  },
  {
    accessor: 'Action',
    Header: 'Action',
    headerProps: {
      className: 'text-end'
    },
    cellProps: {
      className: 'text-end'
    },
    disableSortBy: true,
    Cell: (rowData) => (
      <div>
        <div className="hover-actions bg-100">
            {rowData.row.original.status !="pagado" ?<Button
            onClick={() => handleButtonPayed(rowData.row.original)}
        ><FaCashRegister /></Button>
            :
<ButtonGroup>
  <label className="btn btn-outline-success">
    <input
      type="checkbox"
      checked={rowData.row.original.id}
      onChange={() => setCuotaId(rowData.row.original.id)}
      className="d-none"
    />
    <FaCheckCircle />
  </label>
  <Button onClick={() => setCuotaId(rowData.row.original.id)}>
    <FaBullseye />
  </Button>
</ButtonGroup>
}
        </div>
        <CardDropdown btnRevealClass="btn-reveal-sm" drop="start" />
      </div>
    )
  }
];
const PagosTable = ({cuotas, setCuotaId}) => {
const [ arrToPay , setArrToPay ] = useState([]);
const [ user , setUser ] = useState({});
useEffect(() => {
  const fetchUser = async () => {
    const u = await getUsers();
    user && setUser(u);
  }
  fetchUser();
},[])
const handleButtonPayed = (cuota) => {
    const newArrToPay = arrToPay.length?arrToPay:[];
       (cuota && !newArrToPay.some(item => item.id === cuota.id)) && newArrToPay.push(cuota);
        setArrToPay(newArrToPay);
}

const pagar_cuota = async (arrToPay = []) => {
  if (!Array.isArray(arrToPay) || arrToPay.length === 0) {
    console.warn("No hay cuotas para pagar");
    return;
  }

  try {
    const cuotasConDatos = arrToPay.map(cuota => ({
      ...cuota,
      metodo: "efectivo", 
      status: "pending",
      usuario: user?.name || "Null"
    }));
    for (let i = 0; i < cuotasConDatos.length; i++) {
      //await updateCuotas(cuotasConDatos[i]);
      await updateCuotasFull(cuotasConDatos[i],cuotasConDatos[i].id);
    }
   // await Promise.all(cuotasConDatos.map(updateAlumnoById));

    console.log("Todas las cuotas fueron registradas como pagadas");
  } catch (error) {
    console.error("Error al pagar cuotas:", error);
  }
};

  return (
    <AdvanceTableWrapper
      columns={columns(handleButtonPayed,setCuotaId)}
      data={cuotas}
      selectionColumnWidth={28}
      sortable
      pagination
      perPage={10}
      className="m-1"
    >
      <Card>
        <FalconCardHeader
          title="Recent Leads"
          titleTag="h6"
          className="py-2"
          endEl={<CardDropdown />}
        />
        <Card.Body className="p-0">
          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap hover-actions-trigger btn-reveal-trigger hover-bg-100"
            tableProps={{
              className: 'fs--1 mb-0 overflow-hidden'
            }}
          />
<Row className="align-items-center my-3 m-3">
  <Col>
    <div
      style={{
        fontFamily: 'monospace',
        fontSize: '2rem',
        padding: '10px 20px',
        borderRadius: '8px',
        textAlign: 'right'
      }}
    >
      {new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS'
      }).format(arrToPay.reduce((suma, cuota) => suma + Number(cuota.monto || 0), 0))}
    </div>
  </Col>
  <Col xs="auto">
    <Button onClick={() => pagar_cuota(arrToPay)} size="lg" variant="primary">
      Pagar
    </Button>
  </Col>
</Row>

        </Card.Body>
        <Card.Footer className="p-0">
        </Card.Footer>
      </Card>
    </AdvanceTableWrapper>
  );
};
PagosTable.propTypes = {
    cuotas: PropTypes.array,
    setCuotaId: PropTypes.func
}
export default PagosTable;